import { render } from "./dsgvo.vue?vue&type=template&id=1382bc51"
import script from "./dsgvo.vue?vue&type=script&lang=js"
export * from "./dsgvo.vue?vue&type=script&lang=js"

import "./dsgvo.vue?vue&type=style&index=0&id=1382bc51&lang=scss"

import exportComponent from "F:\\DEV\\estimationpoker\\webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__